module.exports = __webpack_public_path__ + "img/marketplace-icon.4a93c69c.svg";